/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
/**
 * Summary
 * The core Chronos component holds the various contexts (UI, UTD, etc)
 * that are then provided to all children. This component is also
 * responsible for global actions, such as retrieving chronicle data
 * from the Chronos server and saving said chronicle. Individual children
 * will also be able to interact with the global store and read/write
 * data to the server, based on scope (ie, editing an Event) so that
 * the entire UI does not have to refresh.
 */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ChronicleActions, AuthActions, MarkerActions } from "./_actions";
import { useApp } from "./_contexts";

//Import Chronos Sections
import { MapContainer } from "./Map";
import { HistoryContainer } from "./History";
import { Sidebar } from "./Sidebar";
import { GlobalSearch } from "./UI/GlobalSearch";
import { ModalContainer } from "./Modals";
import {
  EventMenu,
  ChronicleAddMenu,
  MapMenu,
  MapPinMenu,
  TimelineNewEventMenu,
} from "./ContextMenus";

// import { DevToast } from './Toasts';
// import { DefaultTemplate, DEFAULT_TEMPLATE } from './_helpers';

export function Chronos({ chronicleID, worldID, userID }) {
  const {
    setUser,
    setEditMode,

    openSidebar,
  } = useApp();
  // const { openModal } = useModal();
  const dispatch = useDispatch();
  const {
    // loading,
    data: initialChronicle,
    // error,
  } = useSelector((state) => state.chronicle);

  //Default Container Classes
  const chronicleClasses = ["chronos-container"];
  useEffect(() => {
    if (initialChronicle && initialChronicle.options) {
      //Add WA ID
      if (initialChronicle.waID) {
        chronicleClasses.push(`chronicle-${initialChronicle.waID}`);
      }

      //Add CustomClass if configured.
      const { customClass } = initialChronicle.options;
      if (customClass && customClass.length > 0) {
        chronicleClasses.push(customClass);
      }
    }
  }, [initialChronicle]);

  useEffect(() => {
    dispatch(AuthActions.login(userID))
      .then((user) => {
        if (!user || user === undefined) {
          user = {};
        }
        //Need to also persist to session storage!
        window.sessionStorage.setItem("chronos-user", JSON.stringify(user));
        return user;
      })
      .then(async (user) => {
        await dispatch(MarkerActions.getMarkerTypes());
        dispatch(ChronicleActions.getChronicle(chronicleID, worldID)).then(
          (chronicle) => {
            if (chronicle !== undefined && chronicle.isEditor) {
              setUser({ ...user, isEditor: true });
              setEditMode(true);
              // openModal('chronosTest');
            } else if (chronicle !== undefined) {
              setUser(user);
              setEditMode(false);
              if (
                chronicle.options &&
                chronicle.options.autoOpenSidebar &&
                chronicle.setupComplete
              ) {
                openSidebar({
                  type: "chronicle",
                  payload: {},
                });
              }
            }
          }
        );
      });
  }, [userID, chronicleID]);

  return (
    <div className={chronicleClasses.join(" ")}>
      {/* Main Containers */}
      {initialChronicle && initialChronicle.setupComplete && (
        <GlobalSearch chronicle={initialChronicle} />
      )}
      <Sidebar />
      <MapContainer />
      <HistoryContainer />
      <ModalContainer />
      {/* Context Menus */}
      <EventMenu />
      <ChronicleAddMenu />
      <MapMenu />
      <MapPinMenu />
      <TimelineNewEventMenu />
      {/* Toast Container */}
      <ToastContainer
        transition={Slide}
        newestOnTop={true}
        className="chronos-toast-container"
        toastClassName="chronos-toast"
        // autoClose={false}
      />
    </div>
  );
}
